export enum LightType {
	DIRECTIONAL = 'directionalLight',
	HEMISPHERE = 'hemisphereLight',
	POINT = 'pointLight',
	SPOT = 'spotLight',
}
export enum THREELightType {
	DIRECTIONAL = 'DirectionalLight',
	HEMISPHERE = 'HemisphereLight',
	POINT = 'PointLight',
	SPOT = 'SpotLight',
}
